import Address from './Address.tsx';
import CDN from './CDN.tsx';
import Change from './Change.tsx';
import ChartAlt from './ChartAlt.tsx';
import Chat from './Chat.tsx';
import Checkmark from './Checkmark.tsx';
import CircleCheckmark from './CircleCheckmark.tsx';
import CircleMinus from './CircleMinus.tsx';
import Close from './Close.tsx';
import Compliance from './Compliance.tsx';
import Copy from './Copy.tsx';
import DayNight from './DayNight.tsx';
import Delete from './Delete.tsx';
import Design from './Design.tsx';
import Development from './Development.tsx';
import DollarSign from './DollarSign.tsx';
import Download from './Download.tsx';
import Drag from './Drag.tsx';
import Duplicate from './Duplicate.tsx';
import ExternalLink from './ExternalLink.tsx';
import Filter from './Filter.tsx';
import Font from './Font.tsx';
import GenerateKeywords from './GenerateKeywords.tsx';
import Globe from './Globe.tsx';
import Groups from './Groups.tsx';
import Growth from './Growth.tsx';
import HeartPulse from './HeartPulse.tsx';
import Import from './Import.tsx';
import List from './List.tsx';
import Logout from './Logout.tsx';
import Mail from './Mail.tsx';
import Merge from './Merge.tsx';
import Minus from './Minus.tsx';
import MobileDevices from './MobileDevices.tsx';
import Paperclip from './Paperclip.tsx';
import Past from './Past.tsx';
import Phone from './Phone.tsx';
import Plus from './Plus.tsx';
import PreviewCrossed from './PreviewCrossed.tsx';
import Radio from './Radio.tsx';
import Reload from './Reload.tsx';
import Retransmit from './Retransmit.tsx';
import RowAdd from './RowAdd.tsx';
import RowRemove from './RowRemove.tsx';
import Rows from './Rows.tsx';
import RSS from './RSS.tsx';
import Running from './Running.tsx';
import Save from './Save.tsx';
import Search from './Search.tsx';
import SidebarToggle from './SidebarToggle.tsx';
import SortingOff from './SortingOff.tsx';
import Spinner from './Spinner.tsx';
import Translate from './Translate.tsx';
import Upload from './Upload.tsx';

export const DefaultIcons = {
  Address,
  CDN,
  Change,
  ChartAlt,
  Chat,
  Checkmark,
  CircleCheckmark,
  CircleMinus,
  Close,
  Compliance,
  Copy,
  DayNight,
  Delete,
  Design,
  Development,
  DollarSign,
  Download,
  Drag,
  Duplicate,
  ExternalLink,
  Filter,
  Font,
  GenerateKeywords,
  Globe,
  Groups,
  HeartPulse,
  Import,
  List,
  Logout,
  Mail,
  Merge,
  Minus,
  MobileDevices,
  Paperclip,
  Past,
  Phone,
  Plus,
  PreviewCrossed,
  Radio,
  Reload,
  Retransmit,
  RowAdd,
  RowRemove,
  Rows,
  RSS,
  Running,
  Save,
  Search,
  SidebarToggle,
  SortingOff,
  Spinner,
  Translate,
  Growth,
  Upload,
};

export default DefaultIcons;
